/**
 * Qualifies the value of PartyDetailRole(1693).
 * - Tag: 1674
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const PartyDetailRoleQualifier = Object.freeze({
    /** Agency */
    Agency: 0,
    /** Principal */
    Principal: 1,
    /** Riskless principal */
    RisklessPrincipal: 2,
    ExchangeOrderSubmitter: 30,
    /** General clearing member */
    GeneralClearingMember: 3,
    /** Individual clearing member */
    IndividualClearingMember: 4,
    PreferredMarketMaker: 5,
    DirectedMarketMaker: 6,
    /** Bank */
    Bank: 7,
    Hub: 8,
    PrimaryTrdRepository: 9,
    OrigTrdRepository: 10,
    AddtnlIntlTrdRepository: 11,
    AddtnlDomesticTrdRepository: 12,
    /** Related exchange */
    RelatedExchange: 13,
    /** Options exchange */
    OptionsExchange: 14,
    /** Specified exchange */
    SpecifiedExchange: 15,
    ConstituentExchange: 16,
    ExemptFromTradeReporting: 17,
    Current: 18,
    New: 19,
    DesignatedSponsor: 20,
    Specialist: 21,
    /** Algorithm */
    Algorithm: 22,
    /** Firm or legal entity */
    FirmOrLegalEntity: 23,
    /** Natural person */
    NaturalPerson: 24,
    RegularTrader: 25,
    HeadTrader: 26,
    Supervisor: 27,
    TriParty: 28,
    Lender: 29,
} as const);

type PartyDetailRoleQualifier = (typeof PartyDetailRoleQualifier)[keyof typeof PartyDetailRoleQualifier];
